import makeStyles from '@mui/styles/makeStyles';
import {convertUrl} from "common/helpers";
import React, {useState} from "react";
import Modal from "@mui/material/Modal";
import ShimmerImage from "components/redesign/ShimmerImage";
import {useSetTranslation} from "common/useSetTranslation";
import { isEmpty } from "lodash";


// A ceiling, not a height: the box hugs the image, so one smaller than this
// does not leave dead space under itself. Tall enough that a worksheet or a
// diagram is readable in the step; the tap-to-expand carries the fine print.
const STEP_IMAGE_MAX_HEIGHT = 420;

const useStyles = makeStyles({
  // Clicking the image opens it; it should not also look picked up or leave a
  // ring behind once the overlay closes.
  trigger: {
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'zoom-in',
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
    // Closing the overlay hands focus back here, and the browser paints that
    // as a ring on an image that is not really "selected".
    '&:focus': {
      outline: 'none',
    },
  },
  image: {
    maxHeight: STEP_IMAGE_MAX_HEIGHT,
  },
});

const JUSTIFY = {LEFT: 'flex-start', CENTER: 'center', RIGHT: 'flex-end'};

export default function StepImage({img, localeImg}) {
  const classes = useStyles();
  const {st} = useSetTranslation();
  const [expanded, setExpanded] = useState(false);

  const inputWidth = `${img.sizePercentage}%` || '100%';
  const imagePath = convertUrl(st(img.path, !isEmpty(localeImg) ? localeImg.path : null));

  return (
    <div style={{margin: '16px 0px', display: 'flex', justifyContent: JUSTIFY[img.alignment] || 'center'}}>
      {/* Capped in the step, so anything with detail in it — a chart, a
          worksheet — has to be openable at its own size. */}
      <button type={'button'} className={classes.trigger} onClick={() => setExpanded(true)}>
        <ShimmerImage
          src={imagePath}
          fit={'natural'}
          placeholderHeight={STEP_IMAGE_MAX_HEIGHT}
          imageClassName={classes.image}
          style={{maxWidth: inputWidth}}
        />
      </button>

      {/* No panel around it: at full size the image is the whole thing, so it
          sits on the backdrop alone. A click anywhere closes it. It is given the
          whole viewport and fitted into it, so it takes the height a portrait
          has to spare and the width a landscape does, rather than stopping at
          the size the file happens to be. */}
      <Modal
        open={expanded}
        onClose={() => setExpanded(false)}
        style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5vh 5vw'}}
      >
        <img
          src={imagePath}
          alt={''}
          onClick={() => setExpanded(false)}
          draggable={false}
          style={{
            display: 'block',
            width: '100%',
            height: '90vh',
            objectFit: 'contain',
            outline: 'none',
            cursor: 'zoom-out',
          }}
        />
      </Modal>
    </div>
  );
};
